import { render } from "./TextSegment.vue?vue&type=template&id=58797bae"
import script from "./TextSegment.vue?vue&type=script&lang=js"
export * from "./TextSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__